export default __webpack_public_path__ + "static/media/highlight.947d9481.svg";